<template>
  <div class="revision-list d-flex flex-column align-stretch w-100">
    <TimelineRow
      v-for="(revision, index) in revisions"
      :key="revision.id"
      :show-connector="revisions.length > 1"
      :is-read-only="index === 0"
      :is-first="index === 0"
      :is-last="index === revisions.length - 1"
      @click="emit('revision-click', { revision, index })"
    >
      <RevisionListItem :revision="{ ...revision, index }">
        <template #before-revision-item>
          <slot
            name="before-revision-item"
            :revision="revision"
          />
        </template>
      </RevisionListItem>
    </TimelineRow>
  </div>
</template>

<script setup>
import RevisionListItem from './RevisionListItem.vue';
import TimelineRow from './TimelineRow.vue';

defineProps({
  revisions: {
    type: Array,
    required: true,
    default: () => [],
  },
});

const emit = defineEmits(['revision-click']);
</script>
